<template>
  <div>
    <ml-header title="我的订单" :dark="true" />
    <div class="order-page">
      <img src="../../assets/personal/order@2x.png" alt="" />
      <p>你还没有订单</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Order"
};
</script>

<style lang="scss" scoped>
.order-page {
  padding-top: 40px;
  img {
    margin-top: 120px;
    width: 76px;
    height: 76px;
  }
  p {
    margin-top: 24px;
    height: 20px;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
  }
}
</style>
